stimulusApp.register(
  "filter-settings",
  class extends Stimulus.Controller {
    toggle(event) {
      // The chevron sits inside the row's `<label>`, whose default action would
      // toggle the filter checkbox itself.
      event.preventDefault()
      event.stopPropagation()
      this.element.dataset.open =
        this.element.dataset.open === "true" ? "false" : "true"
    }
  },
)
